import { isAnswerEmpty } from './survey-answer'
import type { SurveyDefinition, SurveyDraftAnswer, SurveyQuestion } from './survey-question.types'
import {
  surveyQuestionAnswersAfterDescriptionSliderSx,
  surveyQuestionAnswersAfterDescriptionSx,
  surveyQuestionAnswersSx,
} from '../styles/surveyExecutionStyles'

export function surveyQuestionAnswersContainerSx(question: SurveyQuestion) {
  const isSlider = question.type === 'slider'
  const hasDescription = Boolean(question.description)

  if (!hasDescription) {
    return surveyQuestionAnswersSx
  }
  if (isSlider) {
    return surveyQuestionAnswersAfterDescriptionSliderSx
  }
  return surveyQuestionAnswersAfterDescriptionSx
}

export function countAnsweredInDefinition(
  definition: SurveyDefinition,
  answers: Map<string, SurveyDraftAnswer>,
): number {
  return definition.questions.filter((q) => {
    const draft = answers.get(q.id)
    return draft != null && !isAnswerEmpty(q, draft)
  }).length
}
